module.exports = __webpack_public_path__ + "static/media/indesign-cc.873a8237.svg";